module.exports = __webpack_public_path__ + "img/right.08140ef9.png";